import React from "react";
import PropTypes from "prop-types";
import useModal from "@client.hooks/useModal";
import MeetingResponseContent from "./MeetingResponseContent";
import { getRecurringFormat } from "./consts";
import { useTranslation } from "react-i18next";
import { meetingType } from "./types";

const MeetingNameCell = ({ rowData, meetings = [] }) => {
  const { showModal } = useModal();
  const { t } = useTranslation();

  return (
    <span
      className="name-cell"
      onClick={() => {
        showModal({
          title: [
            rowData.name,
            `(${getRecurringFormat({ value: rowData.recurringType }, t)})`,
          ].join(" "),
          component: (
            <MeetingResponseContent rowData={rowData} meetings={meetings} />
          ),
          contentClass: "meeting-response-modal",
          footerButtons: [
            {
              icon: "close",
              text: t("components.Modal.FooterButtons.close"),
              onClick: () => Promise.resolve({}),
            },
          ],
        });
      }}
    >
      {rowData.name}
    </span>
  );
};

MeetingNameCell.propTypes = {
  rowData: meetingType,
  meetings: PropTypes.arrayOf(meetingType),
};

export default MeetingNameCell;
